import React from 'react';
import library from '../assets/img/oasis/library.jpg';
import art from '../assets/img/oasis/art.jpg';
import board from '../assets/img/oasis/digitalboard.jpeg';
import laboratory from '../assets/img/oasis/laboratory.jpg';
import computerlab from '../assets/img/oasis/computerlab.jpg'
import sports from '../assets/img/oasis/sports.jpg';
import camps from '../assets/img/oasis/camps.jpg';
import educationalTour from '../assets/img/oasis/educationaltour.jpeg';
import specialDay from '../assets/img/oasis/specialday.jpeg';
import { Helmet } from "react-helmet-async";

const AdmissionScreen = () => {
  return (
    <>
    <Helmet>
            <title>Admission</title>
            <meta name="description" content="Oasis Educational Institute" />
        </Helmet>
      <div className="font-sans bg-gray-50 text-gray-800 pt-12">
        <div className="relative h-96 flex items-center justify-center bg-cover bg-center" style={{ backgroundImage: "url('/images/admission-hero.jpg')" }}>
          <div className="absolute inset-0 bg-yellow-300 opacity-50"></div>
          <div className="relative text-center text-yellow-700">
            <h1 className="text-3xl font-bold mb-4 pt-2 ">Admissions at Oasis Educational Institute</h1>
            <p className="text-xl  xs:text-sm px-2">Join us in shaping the future of your child</p>
          </div>
        </div>

        
        <div className="container mx-auto px-6 py-12">
          <h2 className="text-3xl font-bold text-center mb-8">Infrastructure and Amenities</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: "Library",
                description: "The school library is the hub of intellectual activities, rich in reading material and reference resources. It provides information and ideas essential for success in today's information and knowledge-based society.",
                image: library,
              },
              {
                title: "Laboratory",
                description: "Our well-equipped science lab provides an experimental foundation for concepts introduced in class. Students enhance their learning through hands-on experiments, kindling their interest visually and kinesthetically.",
                image: laboratory,
              },
              {
                title: "Computer Lab",
                description: "Computer classes at Oasis School are integral to a well-rounded education. Students are instructed on the basics of computer use from Class I onwards.",
                image: computerlab,
              },
              {
                title: "Digital Boards",
                description: "Smart classes with digital boards make learning enjoyable and improve academic performance through engaging visuals and animations.",
                image: board,
              },
              {
                title: "Sports",
                description: "Inclusion of sports in our curriculum is vital for the physical and mental well-being of students.",
                image: sports,
              },
              {
                title: "Art and Craft",
                description: "Art classes teach students creativity, perseverance, and accountability, fostering a well-rounded development.",
                image: art,
              },
              {
                title: "School Camps and Excursions",
                description: "School camps and excursions expose students to different lifestyles, places, and cultures. These activities provide hands-on learning experiences outside the classroom, fostering personal growth and a broader understanding of the world.",
                image: camps,
              },
              {
                title: "Educational Tours",
                description: "Educational tours allow students to gain real-world experiences that enhance and illustrate the concepts taught in the curriculum. These tours introduce students to new environments, ideas, and practical applications of their learning.",
                image: educationalTour,
              },
              {
                title: "Celebration of Special Days",
                description: "Celebrations at Oasis School are an integral part of joyful learning, community building, and thought-provoking processes. Special days are marked with enthusiasm, encouraging students to reflect, connect, and celebrate together.",
                image: specialDay,
              }
            ].map((item, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-md">
                <img src={item.image} alt={item.title} className="w-full h-48 object-cover rounded-t-lg" />
                <h3 className="text-xl font-bold mt-4 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>

     
        <div className="bg-blue-50 py-12">
          <div className="container mx-auto px-6">
            <h2 className="text-3xl font-bold text-center mb-8">Our Curriculum</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[
                {
                  title: "Kindergarten",
                  description: "The kindergarten department mentors children through observation, interaction, and sensory skill development.",
                },
                {
                  title: "Observation and Assessment",
                  description: "Interaction and communication through various activities focus on developing the child's sensory and motor skills.",
                },
                {
                  title: "Primary Department",
                  description: "The primary department focuses on stress-free learning methods, modern tools like smart boards, and regular monitoring of progress.",
                },
                {
                  title: "Middle Department",
                  description: "The middle school curriculum is designed to cover core concepts interactively, with a focus on experiential learning.",
                },
                {
                  title: "Secondary Department",
                  description: "The secondary department emphasizes board exam preparation, oral and aural skills, and practical knowledge through well-equipped labs.",
                },
                {
                  title: "Higher Secondary Department",
                  description: "The Higher Secondary Department provides in-depth knowledge, guiding students to new frontiers of learning. Students are closely monitored and trained, ensuring they are well-prepared and confident for competitive exams."
                }
              ].map((item, index) => (
                <div key={index} className="bg-white p-6 rounded-lg shadow-md">
                  <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                  <p className="text-gray-600">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="container mx-auto px-6 py-12">
          <h2 className="text-3xl font-bold text-center mb-8">Subject Choices for Higher Secondary Department</h2>
          <div className="text-center">
            <p className="text-gray-600">
              <strong>Science</strong><br />
              Group-A: English, Physics, Chemistry, Mathematics, Optional (Physical Education, Islamic Studies, Environmental Science, Functional English)<br />
              Group-B: English, Physics, Chemistry, Biology, Optional (Physical Education, Islamic Studies, Environmental Science, Functional English, Information Practices)<br /><br />
              <strong>Arts and Humanities</strong><br />
              English, History, Political Science, Sociology, Education, Urdu, Optional (Physical Education, Islamic Studies, Environmental Science, Functional English, Information Practices)
            </p>
          </div>
        </div>
       
        <div className="container mx-auto px-6 py-12">
          <h2 className="text-3xl font-bold text-center mb-8">Our Faculty</h2>
          <div className="text-center">
            <p className="text-gray-600">
              Our faculty comprises highly qualified professionals who create an invigorating ambience that kindles the curiosity of every child. We believe in a multi-faceted approach to incorporate all intellectual domains.
            </p>
          </div>
        </div>
        <div className="bg-green-50 py-12">
          <div className="container mx-auto px-6">
            <h2 className="text-3xl font-bold text-center mb-8">Admission Process</h2>
            <div className="text-center">
              <p className="text-gray-600 mb-4">
                To enroll your child, follow these steps:
              </p>
              <ol className="list-decimal list-inside text-gray-600">
                <li>Fill out the registration form available at the school office.</li>
                <li>Submit the required documents, including the child's birth certificate and photographs of the child and parents.</li>
                <li>Pay the non-refundable registration fee of Rs. 500/-.</li>
              </ol>
            </div>
          </div>
        </div>

        <div className="text-center py-12">
          <h2 className="text-3xl font-bold mb-4">Ready to Join Our School?</h2>
          <p className="text-gray-600 mb-8">Take the first step towards your child's bright future</p>
          <button className="bg-blue-900 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-800 transition-colors">
            Start Application Process
          </button>
        </div>

      </div>
    </>

  );
};

export default AdmissionScreen;
